import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const AddNoteOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill={color}>
      <Path d="M6.83 8.67a.8.8 0 0 1 .8-.8H15a.8.8 0 0 1 0 1.6H7.63a.8.8 0 0 1-.8-.8ZM6.83 12.17a.8.8 0 0 1 .8-.8h4.26a.8.8 0 0 1 0 1.6H7.63a.8.8 0 0 1-.8-.8Z" />
      <Path d="M8.22 4.54c-1.902 0-3.37 1.444-3.37 3.09v8.28c0 1.647 1.46 3.09 3.37 3.09h2.93a.8.8 0 0 1 0 1.6H8.22c-2.69 0-4.97-2.057-4.97-4.69V7.63c0-2.634 2.292-4.69 4.97-4.69h6.38c2.69 0 4.97 2.057 4.97 4.69v4.78a.8.8 0 0 1-1.6 0V7.63c0-1.647-1.46-3.09-3.37-3.09H8.22Z" />
      <Path d="M17.51 14.17a.8.8 0 0 0-1.6 0v2.29h-2.3a.8.8 0 0 0 0 1.6h2.3v2.3a.8.8 0 0 0 1.6 0v-2.3h2.29a.8.8 0 0 0 0-1.6h-2.29v-2.29Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AddNoteOutlined
